import React, { ReactNode, useEffect } from 'react'
import styled from "styled-components"
import Img from "gatsby-image"

import { mediaMin, mediaMax } from "../../utils/breakpoints"
import CloseButton from "../Header/components/CloseButton"

interface OverlayFormProps {
	title: string,
	text: string,
	children: ReactNode,
	onClose: () => void,
	show: boolean,
	imageFluid: any
}

export default ({
	title,
	text,
	children,
	onClose,
	show,
	imageFluid,
}:OverlayFormProps) => {

  useEffect(() => {
    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose && onClose()
      }
    }

    if (show && onClose) {
      document.addEventListener("keydown", handleKeydown, false)
    }
    return () => {
      document.removeEventListener("keydown", handleKeydown, false)
    }
  }, [show])

	return (
		<StyledBackground className={show ? "active" : ""}>
      <ClosingDiv onClick={onClose} />
			
			<StyledModal>
				<StyledCloseButton onClick={onClose}></StyledCloseButton>
				<SideImage fluid={imageFluid.childImageSharp.fluid} />

				<ModalContentWrapper>
				<ModalContent>
            <h2>{title}</h2>
            <p>{text}</p>

						{children}
				</ModalContent>
				</ModalContentWrapper>

			</StyledModal>
		</StyledBackground>
	)
}


const SideImage = styled(Img)`
  height: 100%;
  width: 26%;

  @media ${mediaMax.mobileL} {
    display: none;
  }
`

const ModalContent = styled.div`
  width: 67%;

  h2 {
    color: #303030;
    font-family: "Adelle";
    font-size: 30px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 38px;
    margin-bottom: 15px;
  }

  p {
    color: #606060;
    font-family: "Adelle Sans";
    font-size: 18px;
    letter-spacing: 0;
    line-height: 28px;
    max-width: 375px;
    margin-bottom: 35px;
  }
  @media ${mediaMax.tablet} {
    width: 80%;
    margin-top: 40px;
  }

  @media ${mediaMax.mobileS} {
    p {
      margin-bottom: 0;
    }
  }
`

const ModalContentWrapper = styled.div`
  width: calc(100% - 200px);
  margin-top: 12%;
  height: 79%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${mediaMax.tablet} {
    width: 90%;
  }

  @media ${mediaMax.mobileS} {
    margin-top: 0%;
  }
`

const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  top: -25px;
  right: -20px;
`

const StyledBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  pointer-events: none;
  opacity: 0;
  z-index: 0;
  transition: z-index 0.5s step-end, opacity 0.5s cubic-bezier(0.8, 0, 0.07, 1);
  background: linear-gradient(
    135deg,
    rgba(42, 186, 217, 0.25) 0%,
    #8f20a1 100%
  );

  &.active {
    pointer-events: auto;
    transition: z-index 0.5s step-start,
      opacity 0.5s cubic-bezier(0.8, 0, 0.07, 1);
    z-index: 210;
    opacity: 1;
  }
`

const ClosingDiv = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
`

const StyledModal = styled.div`
  width: 67vw;
  position: absolute;
  top: 15vh;
  height: 75vh;
  bottom: 10vh;
  background-color: white;
  display: flex;
  z-index: 30;

  @media ${mediaMax.tablet} {
    width: 90vw;
    height: 95%;
    top: 2vh;
  }
`